/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { flightBookingRoutes } from '../../../../utils/consts/routes';
import { LocationOutlineIcon, EditIcon, ExchangeIcon } from '~svg';
import {
  returnAllPassengerTitle,
  passengersCount,
  passengerType,
  returnShamsiDayWithMonthName,
  returnDayWithMonthName,
} from '../../../../utils/utility/booking';
import {
  ChangeFlightPassengers,
  FlightDetails,
  Modal,
  Tooltip,
} from '../../../../component';
import './flightInfoCard.scss';

const FlightInfoCard = ({
  name,
  intl,
  parsedQueryStr,
  flightType,
  changePassengers,
  currentPage,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showCollapse, setShowCollapse] = useState({
    key: '',
    status: false,
  });
  const wrapperRef = useRef(null);

  let queryStr = new URLSearchParams(parsedQueryStr).toString();
  let direction = name === 'fa' || name === 'ar' ? 'rtl' : 'ltr';
  let selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport'));
  let selectFlight = JSON.parse(sessionStorage.getItem('selectFlight'));
  let passengerCount = passengersCount(parsedQueryStr);
  let passengerTitle = returnAllPassengerTitle(parsedQueryStr, intl),
    homePage = `${flightBookingRoutes.selectCity}?${queryStr}`,
    cabinName = parsedQueryStr.cb || 'economy',
    passengers = {
      Adult: parsedQueryStr.ad ? parseInt(parsedQueryStr.ad) : '1',
      'Child(Age 2-12)': parsedQueryStr.ch ? parseInt(parsedQueryStr.ch) : '0',
      'Infant(Age 0-2)': parsedQueryStr.in ? parseInt(parsedQueryStr.in) : '0',
    };

  const renderFlightDetailModal = (ftype, selectFlight) => {
    return (
      <div className="d-flex justify-content-center align-items-center w-100">
        <div className="d-flex w-100 flex-column justify-content-center p-0 m-0">
          {selectFlight?.itineraries && (
            <FlightDetails
              details={selectFlight}
              flightType={ftype?.toLowerCase()}
              isModal={true}
              showPrice={true}
              bookingId={'1'}
            />
          )}
        </div>
      </div>
    );
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowCollapse({
          ...showCollapse,
          status: false,
        });
        setShowModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className="d-lg-flex flightInfoCard w-100 flex-column text-white font-smaller border-bottom border-1 border-light py-3 px-2 d-none d-lg-block"
    >
      <div className="d-flex w-100 justify-content-start align-items-center pb-3 ">
        <div className="d-flex align-items-center">
          <LocationOutlineIcon size={20} color="#85cd95" />
          {!selectFlight || Object.entries(selectFlight).length === 0 ? (
            <span className="px-2 font-small font-weight-bold">
              <FormattedMessage id="booking.yourchoice" />
            </span>
          ) : (
            <></>
          )}
        </div>
        {selectFlight && Object.entries(selectFlight) ? (
          <div
            className="d-flex px-2 font-smaller font-xl-small cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            <FormattedMessage id="booking.showflightdetail" />
          </div>
        ) : (
          <></>
        )}
      </div>
      <>
        {parsedQueryStr.ft === 'multicity' ? (
          <>
            {selectedAirport.map((item, index) => {
              return (
                <div
                  className="d-flex w-100 justify-content-between align-items-center pt-3 font-msmall  font-weight-bold"
                  key={`flightInfoCard-${index}`}
                >
                  <Tooltip
                    position={'bottom'}
                    content={intl.formatMessage({
                      id: 'booking.changeflight',
                    })}
                    direction={direction}
                    backgroundColor="warning"
                    textColor="dark"
                  >
                    <Link
                      to={`${flightBookingRoutes.selectCity}?${queryStr}`}
                      className="d-flex px-4 text-white align-items-center text-decoration-none"
                    >
                      {`${item.origin.city.locationName[name]}-${item.destination.city.locationName[name]} `}

                      <span className="px-1">
                        <EditIcon size={12} color="#85cd95" />
                      </span>
                    </Link>
                  </Tooltip>
                  <Tooltip
                    position={'bottom'}
                    content={intl.formatMessage({
                      id: 'booking.changedate',
                    })}
                    direction={direction}
                    backgroundColor="warning"
                    textColor="dark"
                  >
                    <Link
                      className="d-flex  text-white align-items-center text-decoration-none "
                      to={`${flightBookingRoutes.selectCity}?${queryStr}
             `}
                    >
                      {name === 'fa'
                        ? item.date && item.date.shamsi
                          ? `${returnShamsiDayWithMonthName(
                              item.date.shamsi.join('-'),
                              'fa',
                            )} - ${returnDayWithMonthName(
                              item.date.miladi.join('-'),
                              'fa',
                            )}`
                          : ''
                        : returnDayWithMonthName(
                            item.date.miladi.join('-'),
                            'en',
                          )}

                      <span className="px-1">
                        <EditIcon size={12} color="#85cd95" />
                      </span>
                    </Link>
                  </Tooltip>
                </div>
              );
            })}

            <div
              className="p-0 cursor-pointer d-flex w-100 justify-content-between text-nowrap"
              id="changePassenger"
            >
              <div className=" dropdown  d-flex align-items-center justify-content-between w-100 pt-3 position-relative">
                {passengerCount > 0 && (
                  <div
                    className={`d-flex font-msmall justify-content-center px-4  flex-row font-weight-bold  text-captalize`}
                  >
                    {`${passengerCount} ${intl.formatMessage({
                      id: `booking.${passengerType(parsedQueryStr)}`,
                    })}`}
                  </div>
                )}
                <div
                  className=" text-white  font-weight-bold text-white align-items-center d-flex justify-content-between  text-nowrap font-msmall"
                  onClick={() => {
                    setShowCollapse({
                      key: 'passenger',
                      status:
                        showCollapse.key === '' ||
                        showCollapse.key !== 'passenger'
                          ? true
                          : showCollapse.key === 'passenger'
                          ? showCollapse.status
                          : !showCollapse.status,
                    });
                  }}
                >
                  <Tooltip
                    position={direction === 'rtl' ? 'left' : 'right'}
                    content={intl.formatMessage({
                      id: 'booking.changepassenger',
                    })}
                    direction={direction}
                    backgroundColor="warning"
                    textColor="dark"
                    customClassName="w-100 text-nowrap"
                  >
                    <span className="text-nowrap">{passengerTitle}</span>
                  </Tooltip>
                  <EditIcon size={12} color="#85cd95" />
                </div>
                {showCollapse.status ? (
                  <div
                    className={`bg-white  passenger-dropdown-${direction} py-0 px-3 shadow-lg default-border-radius-small`}
                  >
                    <div className="d-flex align-items-center justify-content-start py-2 flex-column  pointer">
                      <ChangeFlightPassengers
                        direction={direction}
                        intl={intl}
                        currentPage={currentPage}
                        passengers={passengers}
                        cabinClass={cabinName}
                        changePassengers={(passengers, cabinName) =>
                          changePassengers(passengers, cabinName)
                        }
                        openPassngerDropDown={() => {
                          let dropdown =
                            document.querySelector('#passengerDropdown');
                          if (dropdown) dropdown.classList.add('show');
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <Tooltip
              position={name === 'fa' ? 'left' : 'right'}
              content={intl.formatMessage({
                id: 'booking.changecabinclass',
              })}
              direction={direction}
              backgroundColor="warning"
              textColor="dark"
            >
              <div
                className=" p-0 position-relative cursor-pointer d-flex w-100 justify-content-between pt-3 "
                id="changeClass"
              >
                <div className=" dropdown w-100 d-flex align-items-center justify-content-end">
                  <div
                    className=" text-white py-0 font-weight-bold text-white align-items-center d-flex justify-content-center  font-msmall"
                    onClick={() => {
                      setShowCollapse({
                        key: 'cabin',
                        status:
                          showCollapse.key === '' ||
                          showCollapse.key !== 'cabin'
                            ? true
                            : showCollapse.key === 'cabin'
                            ? !showCollapse.status
                            : showCollapse.status,
                      });
                    }}
                  >
                    <div>
                      <FormattedMessage id={`booking.cabin`} />
                      <span className={`${name === 'fa' ? 'pr-1' : 'pl-1'}`}>
                        <FormattedMessage
                          id={`booking.${
                            parsedQueryStr?.cb?.toLowerCase() || 'economy'
                          }`}
                        />
                      </span>
                      <span className="px-1">
                        <EditIcon size={12} color="#85cd95" />
                      </span>
                    </div>
                  </div>

                  <div
                    id="changeClass"
                    className={`dropdown-menu  passenger-dropdown-${direction} py-0 px-3 shadow-lg  default-border-radius-small`}
                    aria-labelledby="passengerDropdown"
                  >
                    <div className="d-flex align-items-center justify-content-start p-2 flex-column  cursor-pointer">
                      <ChangeFlightPassengers
                        direction={direction}
                        intl={intl}
                        currentPage={currentPage}
                        passengers={passengers}
                        cabinClass={parsedQueryStr.cb}
                        changePassengers={(passengers, cabinName) =>
                          changePassengers(passengers, cabinName)
                        }
                        openPassngerDropDown={() => {
                          let dropdown =
                            document.querySelector('#passengerDropdown');
                          if (dropdown) dropdown.classList.add('show');
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Tooltip>
          </>
        ) : (
          <>
            <div className="w-100 d-flex  flex-column justify-content-center align-items-center pb-3">
              <div className="curve-line position-relative ">
                <div
                  className="d-flex align-items-center justify-content-center flex-column position-absolute col-1"
                  style={{
                    bottom: '-0.6rem',
                    right: direction === 'rtl' ? '-1rem' : '',
                    left: direction === 'ltr' ? '-1rem' : '',
                  }}
                >
                  <div className="path-dot"></div>
                  <div className="position-relative ">
                    <Tooltip
                      position={'top'}
                      content={intl.formatMessage({
                        id: 'booking.editdepartcity',
                      })}
                      direction={direction}
                      backgroundColor="warning"
                      textColor="dark"
                      customClassName={' w-100 d-flex justify-content-around'}
                    >
                      <div className="position-relative d-flex justify-content-between ">
                        <Link
                          style={{
                            transform: `translate(${
                              direction === 'rtl' ? '45%' : '-45%'
                            }, 0%)`,
                          }}
                          to={`${homePage}&focus=inputbooking.from0 `}
                          className={`text-start text-decoration-none cursor-pointer font-msmall px-2  d-flex  justify-content-center align-items-center flex-column font-weight-bold text-white text-nowrap position-absolute`}
                        >
                          {selectedAirport[0].origin.city.locationName[name]
                            .length > 15
                            ? selectedAirport[0].origin.city.locationName[
                                name
                              ].substring(0, 15)
                            : selectedAirport[0].origin.city.locationName[name]}
                        </Link>
                      </div>
                    </Tooltip>
                  </div>
                </div>

                <div
                  className="d-flex align-items-center justify-content-center flex-column position-absolute cursor-pointer"
                  style={{
                    transform: `translate(${
                      direction === 'ltr' ? '80%' : '-124%'
                    }, 65%)`,
                  }}
                  id="changeClass"
                >
                  <Tooltip
                    position={'top'}
                    content={intl.formatMessage({
                      id: 'booking.changecabinclass',
                    })}
                    direction={direction}
                    backgroundColor="warning"
                    textColor="dark"
                  >
                    <div className=" dropdown w-100 d-flex align-items-center justify-content-end">
                      <div
                        className=" text-white py-0 font-weight-bold text-white align-items-center  d-flex justify-content-center  font-msmall"
                        onClick={() => {
                          setShowCollapse({
                            key: 'cabin',
                            status:
                              showCollapse.key === '' ||
                              showCollapse.key !== 'cabin'
                                ? true
                                : showCollapse.key === 'cabin'
                                ? !showCollapse.status
                                : showCollapse.status,
                          });

                          const elements = document.querySelectorAll(
                            `.passenger-dropdown-${direction}`,
                          );

                          elements.forEach((element) => {
                            if (element.classList.contains('show')) {
                              element.classList.remove('show');
                            } else {
                              element.classList.add('show');
                            }
                          });
                        }}
                      >
                        <div>
                          <span
                            className={`${name === 'fa' ? 'pr-1' : 'pl-1'}`}
                          >
                            <FormattedMessage
                              id={`booking.${
                                parsedQueryStr?.cb?.toLowerCase() || 'economy'
                              }`}
                            />
                          </span>
                          <span className="px-1">
                            <EditIcon size={12} color="#85cd95" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>

                <div
                  className="d-flex align-items-center justify-content-center flex-column position-absolute col-1"
                  style={{
                    bottom: '-0.6rem',
                    right: direction === 'ltr' ? '-1rem' : '',
                    left: direction === 'rtl' ? '-1rem' : '',
                  }}
                >
                  <div className="path-dot" />
                  <div className="position-relative ">
                    <Link
                      style={{
                        transform: `translate(${
                          direction === 'rtl' ? '45%' : '-45%'
                        }, 0%)`,
                      }}
                      to={`${homePage}&focus=inputbooking.to0 `}
                      className={`text-start text-decoration-none cursor-pointer px-2 font-msmall d-flex  justify-content-center align-items-center flex-column font-weight-bold text-white position-absolute text-nowrap `}
                    >
                      <Tooltip
                        position={'top'}
                        content={intl.formatMessage({
                          id: 'booking.editdestinationcity',
                        })}
                        direction={direction}
                        backgroundColor="warning"
                        textColor="dark"
                      >
                        {selectedAirport[0].destination.city.locationName[name]
                          .length > 15
                          ? selectedAirport[0].destination.city.locationName[
                              name
                            ].substring(0, 15)
                          : selectedAirport[0].destination.city.locationName[
                              name
                            ]}
                      </Tooltip>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`d-flex w-100 justify-content-between pt-4 font-smaller ${
                parsedQueryStr.ft === 'roundtrip'
                  ? 'flex-column  align-items-end'
                  : ' align-items-center'
              } font-weight-bold`}
            >
              <Tooltip
                position={'bottom'}
                content={intl.formatMessage({
                  id: 'booking.changedate',
                })}
                direction={direction}
                backgroundColor="warning"
                textColor="dark"
                customClassName="w-100"
              >
                <Link
                  className={`d-flex text-decoration-none ${
                    parsedQueryStr.ft === 'roundtrip'
                      ? 'justify-content-between w-100 '
                      : 'justify-content-start '
                  }
              ${direction === 'ltr' ? 'pl-3 ' : ''}
              text-white align-items-center`}
                  id={`tooltip-changeDate`}
                  to={`${flightBookingRoutes.selectCity}?${queryStr}
       `}
                >
                  <>
                    <span>
                      {name === 'fa'
                        ? `${returnShamsiDayWithMonthName(
                            selectedAirport[0].date.shamsi.join('-'),
                            'fa',
                          )} - ${returnDayWithMonthName(
                            selectedAirport[0].date.miladi.join('-'),
                            'fa',
                          )}`
                        : returnDayWithMonthName(
                            selectedAirport[0].date.miladi.join('-'),
                            'en',
                          )}
                    </span>
                    {parsedQueryStr.ft === 'roundtrip' ? (
                      <ExchangeIcon size={18} color="#85cd95" />
                    ) : null}
                    {parsedQueryStr.ft === 'roundtrip' ? (
                      <span>
                        {name === 'fa'
                          ? `${returnShamsiDayWithMonthName(
                              selectedAirport[1].date.shamsi.join('-'),
                              'fa',
                            )} - ${returnDayWithMonthName(
                              selectedAirport[1].date.miladi.join('-'),
                              'fa',
                            )}`
                          : returnDayWithMonthName(
                              selectedAirport[1].date.miladi.join('-'),
                              'en',
                            )}
                        <span className="px-1">
                          <EditIcon size={12} color="#85cd95" />
                        </span>
                      </span>
                    ) : (
                      <span className="px-1">
                        <EditIcon size={12} color="#85cd95" />
                      </span>
                    )}
                  </>
                </Link>
              </Tooltip>
              <div
                className="p-0 position-relative cursor-pointer d-flex   justify-content-end "
                id="changePassenger"
              >
                <div className=" dropdown  d-flex align-items-center justify-content-between w-100 pt-2">
                  <div
                    className=" text-white  font-weight-bold text-white align-items-center d-flex justify-content-between  "
                    onClick={() => {
                      setShowCollapse({
                        key: 'passenger',
                        status:
                          showCollapse.key === '' ||
                          showCollapse.key !== 'passenger'
                            ? true
                            : showCollapse.key === 'passenger'
                            ? !showCollapse.status
                            : showCollapse.status,
                      });
                    }}
                  >
                    <Tooltip
                      position={direction === 'ltr' ? 'left' : 'right'}
                      content={intl.formatMessage({
                        id: 'booking.changepassenger',
                      })}
                      direction={direction}
                      backgroundColor="warning"
                      textColor="dark"
                      customClassName={'text-nowrap'}
                    >
                      <span className="text-nowrap">{passengerTitle}</span>
                      <span className="px-1">
                        <EditIcon size={12} color="#85cd95" />
                      </span>
                    </Tooltip>
                  </div>

                  {showCollapse.status ? (
                    <div
                      className={`bg-white  passenger-dropdown-${direction} py-0 px-3 shadow-lg  default-border-radius-small`}
                    >
                      <div className="d-flex align-items-center justify-content-start py-2 flex-column  pointer">
                        <ChangeFlightPassengers
                          direction={direction}
                          intl={intl}
                          currentPage={currentPage}
                          passengers={passengers}
                          cabinClass={parsedQueryStr.cb}
                          changePassengers={(passengers, cabinName) =>
                            changePassengers(passengers, cabinName)
                          }
                          openPassngerDropDown={() => {
                            let dropdown =
                              document.querySelector('#passengerDropdown');
                            if (dropdown) dropdown.classList.add('show');
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        )}
      </>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={intl.formatMessage({
          id: 'booking.details',
        })}
        titleClass="text-primary"
      >
        {renderFlightDetailModal(flightType, selectFlight)}
      </Modal>
    </div>
  );
};

export default injectIntl(FlightInfoCard);
